import { request } from "./request";
import Cookies from "js-cookie";
import { USER_ID_COOKIES_KEY, USER_TOKEN_COOKIES_KEY, AD_ID_COOKIES_KEY } from "@/utils/constant";
import { getAppID, getIdfp, getVersion } from '@/utils/base'
import { getParam, setStorage, getStorage, browserType } from '@/utils/tools'

export const fetchGetRankingList = function (data) {
  return request({
    url: "/api/v1/books/best_seller",
    method: "post",
    data: { ...data, is_green: true, is_debug: 1, size: 3 }
  })
}

export const fetchGetHomeList = function (data) {
  return request({
    url: "/api/v1/books/list",
    method: "post",
    data: { ...data, is_green: true, is_debug: 1 },
  })
}

export const fetchGetSearchList = function (data) {
  return request({
    url: "/api/v1/pay_books/search",
    method: "post",
    data,
  })
}

export const fetchGetTmpUuid = function (data) {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  let dt = new Date().getTime();
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
  return uuid;
}

export const fetchGetBookDetail = function (data) {
  return request({
    url: "/api/v1/books/detail",
    method: "post",
    data,
    isToast: false
  })
}


export const fetchGetBookChapterList = function (data) {
  return request({
    url: "/api/v1/chapter/list",
    method: "post",
    data,
  })
}

export const fetchGetChapterInfo = function (data) {
  return request({
    url: "/api/v1/chapter/info",
    method: "post",
    data: {
      source: '',
      uuid: Cookies.get(USER_ID_COOKIES_KEY),
      ...data
    },
  })
}


export const fetchGetUserDetail = function (data) {
  return request({
    url: "/api/v1/user/detail",
    method: "post",
    isToast: false,
    isClearToast: 'none',
    data,
  })
}

// 埋点统计上报
export const fetchReportLog = async function (params, others) {
  try {
    const obj = {
      channel: getParam('pid') || '',
      app_id: getAppID(),
      idfp: getIdfp(),
      user_id: Cookies.get(USER_ID_COOKIES_KEY) || 'null',
      reader_version: getVersion(),
      os: '',
      platform: '',
      user_from: '',
      type: '',
      uenter: '',
      uclick: '',
      ad_position: '',
      ad_req: '',
    }
    const reportData = {
      ...obj,
      ...params,
      book_id: '',
      others: {
        url: window.location.href,
        time: Date.now(),
        ...others
      }
    }
    reportData.idfp = +reportData.idfp || 1
    if (reportData.position === 'ad_space') {
      window.plausible('ad_space_report_log');
    }
    try {
      const req = await request({
        url: "/api/v1/data/receive",
        method: "post",
        isToast: false,
        data: { ...reportData, is_debug: 1 }
      })
      if (reportData.position === 'ad_space') {
        window.plausible('ad_space_report');
      }
      return req
    } catch (error) {
      window.plausible('report_error');
      return Promise.reject(error);
    }
  } catch (error) {
    console.log('上报埋点失败', error);
    window.plausible('report_data_error');
    return Promise.reject(error);
  }



}